import React from 'react'
import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { ModalBottom } from '@ui/components/Modal'
import TileGlass from '@ui/tiles/TileGlass'
import Typography from '@ui/typography'
import Price from '@/price/Price'
import { useCustomer } from 'hooks/useSession'

interface Props {
  open: boolean
  close: () => void
}

export default function CreditsModal({ open, close }: Props) {
  const { t } = useTranslation(['modals', 'ui', 'common'])

  const customer = useCustomer()
  const credits = customer?.credit || 0

  return (
    <ModalBottom
      open={open}
      close={close}
      title={t('modals:credits.title')}
      desc={t('modals:credits.desc')}
      body={
        <View className="px-16">
          <TileGlass
            className="overflow-hidden-fixer"
            image={require('@/images/coins.png')}
            imageWrapperStyle={{
              width: '125%',
              height: '125%',
            }}
            imageStyle={{
              transform: [{ translateX: 0 }, { translateY: 40 }],
            }}
            blur={100}
            blurStyle={{
              opacity: 1,
              transform: [{ translateX: 25 }, { translateY: 25 }],
            }}
          >
            <View className="px-16 py-16">
              <View className="gap-1">
                <Typography variant="H3">
                  <Price showZero value={credits} />
                </Typography>
                <Typography variant="MD" className="color-desc">
                  {t('ui:availableCredits')}
                </Typography>
              </View>
            </View>
          </TileGlass>
        </View>
      }
    />
  )
}
